import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { StringIntRequest } from "./StringIntRequest";
import { ParentRelationshipInsertRequest } from "./ParentRelationshipInsertRequest";
import { ParentRelationshipUpdateRequest } from "./ParentRelationshipUpdateRequest";

@Injectable()
export class DataService_GuardianTypeSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadGuardianType(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadGuardianType?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ParentRelationshipCDUsed(parms: StringIntRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ParentRelationshipCDUsed";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ParentRelationshipDescUsed(parms: StringIntRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ParentRelationshipDescUsed";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ParentRelationshipInsert(parms: ParentRelationshipInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ParentRelationshipInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ParentRelationshipUpdate(parms: ParentRelationshipUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ParentRelationshipUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ParentRelationshipSetActive(RelationshipID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ParentRelationshipSetActive?RelationshipID=" + RelationshipID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
